<h1 mat-dialog-title>Notification Log</h1>
<mat-dialog-content>
  @if (loading) {
    <xui-loading-spinner></xui-loading-spinner>
  }
  @if (!loading && notifications.length === 0) {
    <p>No notifications have been sent for this appointment yet.</p>
  }
  @if (!loading && notifications.length > 0) {
    <table mat-table [dataSource]="notifications" class="w-100">
      <ng-container matColumnDef="notificationType">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let row">{{getTypeLabel(row.notificationType)}}</td>
      </ng-container>
      <ng-container matColumnDef="channel">
        <th mat-header-cell *matHeaderCellDef>Channel</th>
        <td mat-cell *matCellDef="let row">{{getChannelLabel(row.channel)}}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">{{getStatusLabel(row.status)}}</td>
      </ng-container>
      <ng-container matColumnDef="recipient">
        <th mat-header-cell *matHeaderCellDef>Recipient</th>
        <td mat-cell *matCellDef="let row">{{getRecipient(row)}}</td>
      </ng-container>
      <ng-container matColumnDef="scheduledSendTime">
        <th mat-header-cell *matHeaderCellDef>Scheduled</th>
        <td mat-cell *matCellDef="let row">{{row.scheduledSendTimeUtc | practiceDateTime:'short'}}</td>
      </ng-container>
      <ng-container matColumnDef="sentTime">
        <th mat-header-cell *matHeaderCellDef>Sent</th>
        <td mat-cell *matCellDef="let row">{{row.sentTimeUtc | practiceDateTime:'short'}}</td>
      </ng-container>
      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef>Subject</th>
        <td mat-cell *matCellDef="let row">{{row.subject}}</td>
      </ng-container>
      <ng-container matColumnDef="result">
        <th mat-header-cell *matHeaderCellDef>Result</th>
        <td mat-cell *matCellDef="let row">{{row.result}}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="mx-3 mb-2">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
